var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-modal click2pay"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.$t('paywall.form.click2pay.modal.title'))}}),_vm._m(0),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.$t('paywall.form.click2pay.modal.processError'))}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/web/img/icons/visa-mastercard-c2p.svg","alt":"Click to Pay Logo"}})])
}]

export { render, staticRenderFns }